import React, { useState } from 'react'
import { Button, Table, Form, Modal } from 'react-bootstrap'

interface ContactsSectionProps {
  customer: any
  setCustomer: React.Dispatch<React.SetStateAction<any>>
}

export const ContactsSection: React.FC<ContactsSectionProps> = ({
  customer,
  setCustomer
}) => {
  const [showContactModal, setShowContactModal] = useState(false)
  const [newContactName, setNewContactName] = useState('')
  const [newContactPhone, setNewContactPhone] = useState('')
  const [phoneError, setPhoneError] = useState('')

  const toogleContactModal = () => {
    setShowContactModal(!showContactModal)
    if (!showContactModal) {
      setNewContactName('')
      setNewContactPhone('')
      setPhoneError('')
    }
  }

  const validatePhone = (phone: string): boolean => {
    return /^9\d{8}$/.test(phone)
  }

  const removeContact = (contact: any) => {
    const updatedContacts = customer.contacts?.filter((c: any) => c.id !== contact.id) || []
    setCustomer({
      ...customer,
      contacts: updatedContacts
    })
  }

  const addContact = (contact: any) => {
    setCustomer({
      ...customer,
      contacts: [...(customer.contacts || []), contact]
    })
  }

  return (
    <>
      <h5 className="mt-4">Contactos</h5>
      <Table bordered size="sm">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Teléfono</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {customer.contacts.map((contact: any) => (
            <tr key={contact.id}>
              <td>{contact.name}</td>
              <td>{contact.phoneNumber}</td>
              <td>
                <div className="d-grid">
                  <Button size="sm" variant="outline-danger" onClick={() => removeContact(contact)}>X</Button>
                </div>
              </td>
            </tr>
          ))}
          <tr>
            <td>
              <div className="d-grid">
                <Button variant="outline-primary" onClick={toogleContactModal}>Agregar contacto</Button>
              </div>
            </td>
            <td colSpan={2}></td>
          </tr>
        </tbody>
      </Table>

      <Modal show={showContactModal} onHide={toogleContactModal}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Contacto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()

            if (!newContactName) {
              return
            }

            if (!validatePhone(newContactPhone)) {
              setPhoneError('El teléfono debe empezar con 9 y tener 9 dígitos')
              return
            }

            const newContact = {
              id: Date.now(), // ID temporal
              name: newContactName,
              phoneNumber: newContactPhone,
              customerId: customer.id
            }
            addContact(newContact)
            toogleContactModal()
          }}>
            <Form.Group controlId="contactName" className="mb-3">
              <Form.Label>Nombre del contacto</Form.Label>
              <Form.Control
                placeholder="Nombre del contacto"
                value={newContactName}
                onChange={e => setNewContactName(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group controlId="contactPhone" className="mb-3">
              <Form.Label>Teléfono</Form.Label>
              <Form.Control
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Ej: 987654321"
                maxLength={9}
                value={newContactPhone}
                onChange={e => {
                  const value = e.target.value.replace(/\D/g, '');
                  setNewContactPhone(value)
                  setPhoneError('')
                }}
                isInvalid={!!phoneError}
                required
              />
              {phoneError && (
                <Form.Control.Feedback type="invalid">
                  {phoneError}
                </Form.Control.Feedback>
              )}
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={toogleContactModal}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Agregar
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}